/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Creates a debounced function that delays invoking the provided function
 * until after the specified milliseconds have elapsed since the last time
 * the debounced function was invoked.
 *
 * @param callback - The function to debounce.
 * @param delay - The number of milliseconds to delay. Defaults to 200ms.
 * @returns A new debounced function.
 * @example const debounced = debounce(() => console.log("Hello, World!"), 1000);
 */
export const debounce = <T extends (...args: any[]) => any>(
  callback: T,
  delay: number = 200,
): ((...args: Parameters<T>) => void) => {
  let timeout: ReturnType<typeof setTimeout>;

  return function (this: unknown, ...args: Parameters<T>) {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(this, args), delay);
  };
};
